import { getStatusDescriptionFromStatusValue } from '../../../../../utils/utility';
import { getDateWithSpecificFormat } from '../../../../data-transform';

const constructCountryNames = (countries = []) => {
    // let countriesList = countries.map(country => {
    //     return getCountryNameByCountryCode(country);
    // });
    return countries.join(", ");
}

export default function vendorResultsColumnSpecification(config) {
    if (!config.data) return null;
    const { vendorQuoteDetails = [], conversionRateType = '', quoteDetails = {}, currencyCode, countryList, countryCurrency } = config.data;
    let result = {};
    let tableData = [];


    const getCurrencyCode = () => {
        if (conversionRateType === 'USD' || conversionRateType === 'EUR') {
            return conversionRateType
        }
        else if (quoteDetails.region === "EMEA" && countryList.length > 1) {
            return "EUR"
        }
        else if (countryList.length === 1) {
            return countryCurrency[countryList[0]]
        } else if (countryList.length > 1) {
            return "USD"
        }
    }

    vendorQuoteDetails.forEach((quote, index) => {
        let row = [];
        const rowId = config.tableType;

        config.columns.forEach(column => {
            const columnId = column.id;
            const displayAsIs = column.data.displayInBodyAsIs;
            const columnDataType = column.data.displayInBodyAs;
            const highlightColumn = column.data.highlightBodyText;
            let highlightColor = false;

            let columnValue = null;
            let isDisabled = quote.refused ? true : false;
            let columnValueData = null;

            if (columnDataType === "string") {
                if (columnId === "quotationNumber") {
                    columnValue = quote.quotationNumber;
                }
                if (columnId === "priceHardware") {
                    columnValue = "Custom Quote";
                }
                if (columnId === "priceService") {
                    if (quoteDetails.selectedServicePriceList) {
                        columnValue = quoteDetails.selectedServicePriceList === "standard" ? "Standard Service Rate Card" : "Custom Service Rate Card";
                    } else {
                        columnValue = quoteDetails.rateCardSelection === "service_customquoteforhardware" ? "Standard Service Rate Card" : "Custom Quote";
                    }
                    if (quoteDetails.priceService[quote.quotingPartners]) {
                        columnValue = quoteDetails.priceService[quote.quotingPartners];
                    }
                    if (quoteDetails.priceService[quote.quotingPartners] === "Custom Quote") {
                        highlightColor = true;
                    }
                }
                if (columnId === "quotingPartners") {
                    columnValue = quote.quotingPartners;
                }
                if (columnId === "quoteSubmissionDateByVendor") {
                    columnValue = getDateWithSpecificFormat(quote.quotationSubmissionDate);
                }
                else if (columnId === "listOfCountriesQuoted") {
                    columnValue = quote.countryList ? constructCountryNames(quote.countryList) : "";
                }
                else if (columnId === "numberOfCountries") {
                    columnValue = quote.totalCountries || "0";
                }
                else if (columnId === "currency") {
                    columnValue = getCurrencyCode() || '';
                }
                else if (columnId === "vendorBuybackValue") {
                    if (getCurrencyCode() === 'USD') {
                        columnValue = quote?.vhardwareCostInUSD?.toFixed(2);
                    } else {
                        columnValue = quote?.vhardwareCost?.toFixed(2);
                    }
                    isDisabled = quote.refused && true;
                }
                else if (columnId === "vendorProcessingAndLogisticCosts") {
                    // //Fix for SUPP2-6040
                    if (getCurrencyCode() === 'USD') {
                        if (quote.vprocessingCostInUSD !== null || quote.vlogisticCostInUSD !== null) {
                            columnValue = (quote?.vprocessingCostInUSD + quote?.vlogisticCostInUSD)?.toFixed(2);
                        }
                    } else {
                        if (quote.vprocessingCost !== null || quote.vlogisticCost !== null) {
                            columnValue = (quote?.vprocessingCost + quote?.vlogisticCost)?.toFixed(2);
                        }
                    }
                }
                else if (columnId === "vendorNetValue") {
                    if (getCurrencyCode() === 'USD') {
                        columnValue = quote?.vnetValueInUSD?.toFixed(2);
                    } else {
                        columnValue = quote?.vnetValue?.toFixed(2);
                    }
                }
                else if (columnId === "vendorRevitalizeFees") {
                    columnValue = quote?.vhardwareRevitalizeCost?.toFixed(2);
                }
                else if (columnId === "vendorQuoteStatus") {
                    columnValue = getStatusDescriptionFromStatusValue(quote.status || "VENDOR_PRICES_PENDING");
                }
                else if (columnId === "vendorDiscardReason") {
                    columnValue = getStatusDescriptionFromStatusValue(quote.refusedReason);
                }
            }

            row.push({
                [columnId]: {
                    id: columnId + "|" + rowId,
                    columnId: columnId,
                    type: columnDataType,
                    value: columnValue,
                    width: column.width,
                    displayAsIs: displayAsIs,
                    showInMobileViewAs: column.showInMobileViewAs,
                    highlightColumn: highlightColumn,
                    disabled: isDisabled,
                    RedBoldColor: highlightColor,
                    clickHandler: (columnDataType !== "string" && config.inputHandler) ? event => config.bodyButtonsHandler(event, columnId, index) : null
                }
            });
        });

        tableData.push({
            id: rowId,
            data: row
        });
    })

    result['columns'] = config.columns || [];
    result['data'] = tableData || [];

    return result;
}